import React from "react";
import { Wrapper, Image } from "./styled";
import Folder from "../../../../images/commonFolder.svg";

const CommonFolderIcon = () => {
  return (
    <Wrapper>
      <Image src={Folder} alt="icon" />
    </Wrapper>
  );
};

export default CommonFolderIcon;
